<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: 'postage-cost',
};
</script>

<style>
</style>
